import api from 'repositories/api'
import { IMonthGoal, IUserWorking } from 'store/modules/goal/types'

export interface StoreLastActiveData {
  storeId: string
  storeName: string
  sourceGoalId?: string
  sourceMonth?: string
  commissionConfig: {
    directCommission: boolean | null
    splitCommission: boolean | null
    distribute: boolean | null
    storeSold: boolean | null
    sections: Array<{ start: string | Date; end: string | Date }>
  } | null
  valueConfig: {
    base: number | null
    complement: boolean | null
    dsr: number | null
    total: number | null
    ticket: number | null
    price: number | null
  } | null
  sellerGoalConfig: {
    fixedCommission: number | null
    usersWorking: IUserWorking[]
    monthGoals: IMonthGoal[]
  } | null
}

export const fetchBulkLastActiveData = async (storeIds: string[]): Promise<StoreLastActiveData[]> => {
  const { data } = await api.axios.post<StoreLastActiveData[]>('/store/bulk-goal-last-active-data', { storeIds })
  return data
}
